export const HEALTH_HISTORY_VISIBLE_SECTION = {
  BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  TEMPERATURE: 'TEMPERATURE',
  WEIGHT: 'WEIGHT',
  PULSE: 'PULSE',
  CHOLESTEROL: 'CHOLESTEROL',
  HEMOGLOBIN: 'HEMOGLOBIN',
}

export const HEALTH_HISTORY_VISIBLE_SECTION_OPTIONS = [
  {
    value: HEALTH_HISTORY_VISIBLE_SECTION.BLOOD_PRESSURE,
    label: 'Blood Pressure',
  },
  { value: HEALTH_HISTORY_VISIBLE_SECTION.TEMPERATURE, label: 'Temperature' },
  { value: HEALTH_HISTORY_VISIBLE_SECTION.WEIGHT, label: 'Weight' },
  { value: HEALTH_HISTORY_VISIBLE_SECTION.PULSE, label: 'Pulse' },
  { value: HEALTH_HISTORY_VISIBLE_SECTION.CHOLESTEROL, label: 'Cholesterol' },
  { value: HEALTH_HISTORY_VISIBLE_SECTION.HEMOGLOBIN, label: 'Hemoglobin' },
]

export const ALL_HEALTH_HISTORY_VISIBLE_SECTIONS =
  HEALTH_HISTORY_VISIBLE_SECTION_OPTIONS.map(option => option.value)

export const HEALTH_HISTORY_SECTION_TITLE_TO_ENUM = {
  'Blood Pressure': HEALTH_HISTORY_VISIBLE_SECTION.BLOOD_PRESSURE,
  Temperature: HEALTH_HISTORY_VISIBLE_SECTION.TEMPERATURE,
  Weight: HEALTH_HISTORY_VISIBLE_SECTION.WEIGHT,
  Pulse: HEALTH_HISTORY_VISIBLE_SECTION.PULSE,
  Cholesterol: HEALTH_HISTORY_VISIBLE_SECTION.CHOLESTEROL,
  Hemoglobin: HEALTH_HISTORY_VISIBLE_SECTION.HEMOGLOBIN,
}

export function getVisibleHealthHistorySections(configurationOptions = []) {
  const config = configurationOptions.find(
    item => item.code === 'HEALTH_HISTORY_VISIBLE_SECTIONS'
  )

  if (!config) {
    return [...ALL_HEALTH_HISTORY_VISIBLE_SECTIONS]
  }

  if (!config.value?.trim()) {
    return []
  }

  return config.value
    .split(',')
    .map(section => section.trim())
    .filter(section => ALL_HEALTH_HISTORY_VISIBLE_SECTIONS.includes(section))
}

export function isHealthHistorySectionVisible(
  title,
  configurationOptions = []
) {
  const sectionKey = HEALTH_HISTORY_SECTION_TITLE_TO_ENUM[title]
  if (!sectionKey) {
    return false
  }

  return getVisibleHealthHistorySections(configurationOptions).includes(
    sectionKey
  )
}
